var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle122(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "438.2854093840633 513.3940499267588 15.090110454995113 16.464091712540835",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M442.29,522.33c-.12-3.63,2.13-5.55,4.71-4.76,1.44.44,2.46,1.79,2.37,3.28-.12,2.04-1.3,3.51-2.87,4.65-.93.67-2.49.37-3.11-.65-.59-.96-.92-2.08-1.1-2.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle122);
export default __webpack_public_path__ + "static/media/twinkle-1-22.1a2e505965c53f7c2da143f5d17a72de.svg";
export { ForwardRef as ReactComponent };